<template>
  <div id="mqttws" class="mqttws">
    <!-- <input type="text" id="msg" v-model="msg"/> -->
    <!-- <input type="button" value="Send" @click="send(msg)" />
    <input type="button" value="Start" @click="start"/>
    <input type="button" value="Stop" @click="stop"/> -->
  </div>
</template>
<script>
import {Uint8ArrayToString,strToHexCharCode} from '../../static/js/utils/util.js'
import {conLog} from '../../static/js/utils/utility.js'
import * as config from '../../static/js/config.js';
  export default {
    name: 'mqttws',
    props:{
      topic:{
        type: String,
        required: true
      },
      msg:{
        type: String,
        required: true
      },
      isConnect:{
        type:Boolean
      },
      topic2:{
        type: String,
        required: false
      },
      msg2:{
        type: String,
        required: false
      },
      isSend:{
        type:Boolean,
        required:false,
      },
    },
    data() {
      return {
        // hostname: '47.107.118.123',//地址
        hostname: config.serverPort,//地址
        port: 61614,//端口号
        clientId: config.deviceId+'GJG'+Math.random()*10,//clientId
        timeout: 5,
        keepAlive: 10,
        cleanSession: true,
        ssl: false,
        userName: 'admin',
        password: 'admin',
        client:{},
        options: {},

        isMqttwsCont:false,
      }
    },
    created : function() {
      var that = this
      // var isMqttCont = this.$store.state.isMqttCont
      // if(isMqttCont == true){
        this.onConnection();
      // }else{
        // if(that.isSend){
        //   that.send(that.topic2,that.msg2)
        // }
        // if(that.isConnect){
        //   that.subscribe(that.topic);//订阅主题
        // }
      // }
    },
    mounted : function (){
      // var opt = this.options;
      // this.client.connect(opt);//连接服务器并注册连接成功处理事件
      // this.client.onConnectionLost = this.onConnectionLost;//注册连接断开处理事件
      
      // this.client.onMessageArrived = this.onMessageArrived;//注册消息接收处理事件
      // console.log('after onlost');
    },
    // watch:{
    //   "$store.state.isMqttCont":async function(newVal, oldVal) {
    //     console.log('newVal',newVal)
    //     if(newVal == true){
    //       this.onConnection()
    //     }
    //   },
    // },
    methods: {
      //开始连接
      onConnection(){
        var that = this;
        this.isMqttwsCont = false,
        this.client = new Paho.MQTT.Client(this.hostname, this.port, this.clientId);
        var _client=this.client;
        var opt = this.options =
          {
            invocationContext: {
              host: that.hostname,
              port: that.port,
              path: _client.path,
              clientId: that.clientId
            },
            timeout: that.timeout,
            keepAliveInterval: that.keepAlive,
            cleanSession: that.cleanSession,
            useSSL: that.ssl,
            userName: that.userName,
            password: that.password,
            onSuccess: function(res) {
              conLog("连接成功",res);
              
              if(that.isConnect){
                _client.subscribe(that.topic);//订阅主题
              }
              if(that.isSend){
                that.send(that.topic2,that.msg2)
              }
            },
            onFailure: function (e) {
              conLog('链接失败：',e);
              // that.$message.error('设备ID被占用或通讯断开,正在重连')
              // that.isConnect = true
              that.onConnection()
            }
          };
        
        this.client.onConnectionLost = this.onConnectionLost;//注册连接断开处理事件

        this.client.onMessageArrived = this.onMessageArrived;//注册消息接收处理事件
        this.client.connect(opt);//连接服务器并注册连接成功处理事件
      },
      //连接已断开
      onConnectionLost(responseObject) {
        var that = this;
        if (responseObject.errorCode !== 0) {
          // that.$message.error('设备ID被占用或通讯断开,正在重连')
          // that.isConnect = true
          that.onConnection()
          // console.log("连接已断开",responseObject.errorMessage)
        }
      },
      //收到消息
      onMessageArrived(message) {
        // console.log(message);
        var msg = Uint8ArrayToString(message.payloadBytes)
        msg = strToHexCharCode(msg)
        conLog("收到消息:",msg);
        this.$emit('getMessage',msg)
      },
      
      //订阅主题
      onConnect(topic) {
        conLog("订阅成功！",topic);
        this.client.subscribe(topic);//订阅主题
      },
      //发送消息
      send(topic,msg){
        conLog('send',topic,msg)
        var s = msg;
        if(s){
          var strArr = [];
          var n = 2;
          for (var i = 0, l = s.length; i < l/n; i++) {
            var a = s.slice(n*i, n*(i+1));
            a = parseInt(a, 16);
            // a = hex_to_bin(a);//把数组的每个元素转成10进制数据
            strArr.push(a);
          }
          //把10进制数据放进uint8array对象传过去
          var uint8Arr = new Uint8Array(strArr);
          var message = new Paho.MQTT.Message(uint8Arr);
          message.destinationName = topic;
          // message.qos = 0
          // message.retain = 0
          this.client.send(message);
          msg = '';//如果为空，第二次就不能发送空消息了
        }
      },
      start(){
        window.tester = window.setInterval(function(){
          if(this.client.isConnected){
            var s = this.msg;
            var message = new Paho.MQTT.Message(s);
            message.destinationName = this.topic;
            this.client.send(message);
          }
        }.bind(this), 1000);
      },
      stop(){
        window.clearInterval(window.tester);
        // this.client.disconnect();
        // console.log('已断开')
      },
      //断开mqtt
      disconnect(){
        this.isMqttwsCont = true
        conLog('disconnect已断开连接')
        this.client.disconnect();
      }
    },
    destroyed(){
      conLog('destroyed已断开连接')
      if(this.isMqttwsCont == false){
        this.client.disconnect();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/assets/mqttws.vue